import { createApi } from "@reduxjs/toolkit/query/react";
import config from "../config";
import baseQueryWithCorrelationId from "../services/baseQueryWithCorrelationId";


const generateUrl = (viewId, subscriptionId = "") =>
    `/data-views/${process.env.REACT_APP_API_VERSION}/${viewId}/subscriptions${subscriptionId}${config.REACT_APP_ENV_NAME}`;

const saveReportViewReminderSlice = createApi({
    reducerPath: "saveReportViewReminder",
    baseQuery: baseQueryWithCorrelationId(config.REACT_APP_API_URL),
    endpoints: (builder) => ({
        saveReportViewReminder: builder.mutation({
            query: ({ dataToUpdate, viewId }) => ({
                url: generateUrl(viewId),
                method: "POST",
                body: JSON.stringify(dataToUpdate),
            }),
        }),
        updateReportViewReminder: builder.mutation({
            query: ({ dataToUpdate, viewId, SubscriptionId }) => ({
                url: generateUrl(viewId, `/${SubscriptionId}`),
                method: "PUT",
                body: JSON.stringify(dataToUpdate),
            }),
        }),
        deleteReportViewReminder: builder.mutation({
            query: ({ dataToUpdate, viewId }) => ({
                url: generateUrl(viewId, `/${dataToUpdate.SubscriptionId}`),
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useSaveReportViewReminderMutation,
    useUpdateReportViewReminderMutation,
    useDeleteReportViewReminderMutation,
} = saveReportViewReminderSlice;

export default saveReportViewReminderSlice;
